module.exports = __webpack_public_path__ + "static/media/check.d093f859.svg";